import { ReactNode } from "react";
import { HorizontalLayout } from "src/components/common/Layout";

interface MxReactToggleBarProps {
  children: ReactNode;
}
export const MxReactToggleBar = (props: MxReactToggleBarProps) => (
  <HorizontalLayout childSpacing={1}>{props.children}</HorizontalLayout>
);
